export default "__VITE_ASSET__07b07845__"